import React, { useState } from 'react';
import ProviderIcon from './ProviderIcon';

/**
 * A git account's picture, or its provider's icon. GitLab answers with a
 * Gravatar (or the server's own) avatar URL, and the app's CSP allows images
 * from GitHub and Apiboo's hosts only — so a GitLab account rendered a broken
 * image (seen in the Windows Sandbox videos, 03.10.2026). Any avatar that does
 * not load falls back to the provider's icon from the icon library.
 */
// Pictures that loaded once this session stay decoded in memory, so revisiting
// the Git page paints them in the same frame instead of fetching and fading in
// again (owner, 04.10.2026: "the avatar reloads each time").
const loaded = new Map(); // url -> HTMLImageElement
function remember(url) {
  if (!url || loaded.has(url) || typeof Image === 'undefined') return;
  const img = new Image();
  img.decoding = 'async';
  img.src = url;
  loaded.set(url, img);
}

export default function AccountAvatar({ account, size = 16 }) {
  // Remembers WHICH url failed, so a new picture (another sign-in) is tried again.
  const [failedUrl, setFailedUrl] = useState(null);
  const url = account?.avatarUrl;
  if (!url || failedUrl === url) return <ProviderIcon id={account?.provider} size={size} />;
  return (
    <img
      className="git-avatar"
      src={url}
      alt=""
      decoding={loaded.has(url) ? 'sync' : 'async'}
      onLoad={() => remember(url)}
      onError={() => {
        loaded.delete(url);
        setFailedUrl(url);
      }}
    />
  );
}
